<template>
  <v-card class="pa-4 px-6" flat>
    <v-dialog v-model="dialog" max-width="500px">
      <ConfirmModal
          textMessage="Você confirma que o pedido for reembolsado?"
          textObservation1="Certifique-se que o pedido foi reembolsado junto ao cliente."
          cancelBtn="Cancelar"
          okbtn="Confirmar"
          @close="dialog = false"
          @action="confirmRefund()"
      />
    </v-dialog>

    <div class="d-flex align-center">
      <h3>Pedidos de reembolso </h3>
      <v-spacer></v-spacer>
      <v-btn icon @click="excel">
        <v-icon>mdi-download</v-icon>
      </v-btn>
    </div>

    <v-divider class="ma-2"></v-divider>

    <v-data-table
        :items="items"
        :loading="loading"
        :headers="headers"
        class="content-table"
        style="cursor: pointer"
        hide-default-footer
        loading-text="Buscando..."
        no-data-text="Sem registros"
        @click:row="handleRowClick"
    >
      <template v-slot:[`item.done`]="{ item }">
        <p :class="item.done ? 'done':'not_done'">{{ item.done ? 'Sim' : 'Não' }}</p>
      </template>

      <template v-slot:[`item.value`]="{ item }">
        <p>{{ item.value ? formatCurrency(item.value) : '-' }}</p>
      </template>

      <template v-slot:[`item.dateDone`]="{ item }">
        <p class="mt-1">{{ item.dateDone ? formatDate(item.dateDone) : 'Não reembolsado' }}</p>
      </template>

      <template
          v-slot:[`item.actions`]="{ item }"
          cols="12"
          md="6"
          xs="12"
          sm="12"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                outlined
                fab
                tile
                :disabled="item.done"
                small
                class="edit-button"
                @click="showDoneModal(item, $event)"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon color="#8dc63f" dark>mdi-check-bold</v-icon>
            </v-btn>
          </template>
          <span>Marcar como feito</span>
        </v-tooltip>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="pageCount"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import ConfirmModal from "../../components/ConfirmModal";
import Vue from "vue";
import Utils from "../../../../Utils/FormatDate";
import Pagination from "@/views/pages/components/Pagination.vue";
import UtilsFormatCurrency from "@/Utils/FormatCurrency";

export default {
  name: "Reimbursement",
  components: {
    Pagination,
    ConfirmModal
  },
  props: {
    filter: Object,
  },

  created() {
    this.list();
  },

  data() {
    return {
      pageCount: 1,
      reimbursement: null,
      items: [],
      loading: false,
      dialog: false,
      apiService: new ApiService(),
      headers: [
        {
          text: "Cliente",
          align: "center",
          sortable: false,
          value: "user.name",
        },
        {
          text: "E-mail",
          align: "center",
          sortable: false,
          value: "user.email",
        },
        {
          text: "Revenda",
          align: "center",
          sortable: false,
          value: "resale.nameFantasy",
        },
        {
          text: "Pedido",
          align: "center",
          sortable: false,
          value: "order.orderCode",
        },
        {
          text: "Valor",
          align: "center",
          sortable: false,
          value: "value",
        },
        {
          text: "Data do reembolso",
          align: "center",
          sortable: false,
          value: "dateDone",
        },
        {
          text: "Reembolsado",
          align: "center",
          sortable: false,
          value: "done",
        },
        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      page: 1,
      pageSize: 10,
      currentPage: 10,
      totalItems: 10,
    };
  },

  methods: {
    formatCurrency(value) {
      return UtilsFormatCurrency.formatCurrency(value);
    },
    formatDate(date) {
      return Utils.moment(date);
    },
    list() {
      try {
        this.loading = true;

        this.apiService
            .post(
                "dashboard/reimbursement",
                {...this.filter, page: this.page},
                false,
                false,
                false
            )
            .then((response) => {
              this.items = response.content.data;
              this.pageCount = response.content.pager.totalPages;
              this.totalItems = response.content.pager.totalItems;
              this.currentPage = response.content.pager.currentPage;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
      }catch (e) {

      }
    },

    async backPage() {
      this.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.page += 1;
      await this.list();
    },

    excel() {
      this.loading = true;

      this.apiService
          .post(
              "dashexport/reimbursement",
              { ...this.filter, page: this.page },
              false,
              false,
              true
          )
          .then((response) => {
            const excel =
                "data:application/octet-stream;base64," + response.content;
            const link = document.createElement("a");
            link.href = excel;
            link.setAttribute("download", `reembolsos.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    showDoneModal(item, event) {
      event.stopPropagation();
      this.reimbursement = item
      this.dialog = true
    },

    async handleRowClick(item) {

      await this.$router.push({
        path: `/order-detail?id=` + item.order.id,
        params: item,
      });
    },

    confirmRefund() {
      try {
        this.dialog = false
        this.apiService.put("dashboard/confirm-refund", this.reimbursement, false, false, true)
            .then((response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: response.message ? response.message  : "O pedido de reembolso foi marcado como concluído.",
                trace: null,
              });
              this.list()
            })
            .catch(() => {
              this.loading = false;
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "",
                message: "Não foi possível marcar o pedido de reembolso como concluído.",
                trace: null,
              });
            });
      } catch (e) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Não foi possível marcar o pedido de reembolso como concluído.",
          trace: null,
        });
      }
    }
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.list();
      },
    },
  },
};
</script>

<style>
.done {
  color: #FFFFFF;
  padding: 5px;
  border-radius: 3px;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
  background: #8dc63f !important;
}

.not_done {
  margin-top: 10px;
  color: #FFFFFF;
  padding: 5px;
  border-radius: 3px;
  font-weight: bold;
  text-align: center;
  background: #e30011 !important;
}

.edit-button {
  margin-top: -5px !important;
  border: 1px solid #8dc63f !important;
  border-radius: 4px;
  width: 35px !important;
  height: 30px !important;
}
</style>
